<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>跑马灯配置</span>
          <CommonExport :import-p="'config:noticeMsg:import'" :export-p="'config:noticeMsg:export'" :get-table="getTables" :import-method="importNoticeMsg" :export-method="exportNoticeMsg" />
          <clear-cache-apply />
          <sync-data />
        </div>
        <el-table :data="tableData" border stripe>
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <el-select v-model.number="scope.row.type" filterable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="是否启用">
            <template slot-scope="scope">
              <el-select v-model.number="scope.row.conf.status" placeholder="请选择">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="配置">
            <template slot-scope="scope">
              <el-button type="primary" @click="drawerArr[scope.$index].visible = true">配置</el-button>
              <el-drawer
                title="配置"
                :visible.sync="drawerArr[scope.$index].visible"
                :with-header="false"
                size="1200px"
              >
                <el-form>
                  <el-form-item v-if="scope.row.type === 'getMaxSpins'" label="最大体力">
                    <el-input v-model.number="scope.row.conf.maxSpins" style="width: 600px;" placeholder="最大体力" />
                  </el-form-item>
                  <el-form-item label="语言" prop="langs">
                    <el-select v-model="tableData[scope.$index].langs" style="width: 1000px" multiple placeholder="请选择" @change="(v)=>changeLang(v, scope.$index)">
                      <el-option
                        v-for="(item, index) in lang"
                        :key="index"
                        :label="item"
                        :value="index"
                      />
                    </el-select>
                    <!--                    <el-upload-->
                    <!--                      ref="upload"-->
                    <!--                      style="display: inline-block"-->
                    <!--                      class="upload-demo"-->
                    <!--                      :action="sys_app_logoAction"-->
                    <!--                      accept="xlsx"-->
                    <!--                      :limit="1"-->
                    <!--                      :on-success="(res)=>{return importUploadSuccess(res, scope.$index)}"-->
                    <!--                      :headers="headers"-->
                    <!--                    >-->
                    <!--                      <el-button style="margin-left: 10px" :loading="loading" icon="el-icon-upload2" type="primary">导入</el-button>-->
                    <!--                    </el-upload>-->
                  </el-form-item>
                  <el-form-item v-for="(item, index) in scope.row.content" :key="index" :label="lang[index]">
                    <el-input v-model="scope.row.content[index]" style="width: 600px;" :placeholder="lang[index]" />
                  </el-form-item>
                </el-form>
              </el-drawer>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="操作">
            <template slot-scope="scope">
              <el-button v-permisaction="['config:noticeMsg:del']" type="danger" @click="del(scope.row.type)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align: center;margin-top: 20px">
          <el-button v-permisaction="['config:noticeMsg:add']" type="primary" @click="edit()">+</el-button>
          <el-button v-permisaction="['config:noticeMsg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import CommonExport from '@/components/CommonExport/index.vue'
import { importGameUpdateLang } from '@/api/config/game-update-cfg'
import submenu from 'element-ui/packages/submenu'
import {
  delNoticeMsg,
  exportNoticeMsg,
  getNoticeMsg,
  getNoticeMsgType,
  importNoticeMsg,
  updateNoticeMsg
} from '@/api/config/notice-msg'
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'NoticeMsg',
  components: {
    SyncData,
    ClearCacheApply,
    CommonExport
  },
  data() {
    return {
      loading: false,
      drawerArr: [{ visible: false }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      statusType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      options: [],
      formData: {},
      tableData: [{ type: '', content: {}, conf: {}}],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      lang: {
        'EN': '英 文',
        'ZH': '中 文',
        'TW': '繁 体',
        'FR': '法 语',
        'DE': '德 语',
        'ES': '西班牙',
        'PT': '葡萄牙',
        'TH': '泰 语',
        'VN': '越 南',
        'NO': '挪 威',
        'ID': '印 尼',
        'IT': '意大利',
        'MY': '马来西亚',
        'RO': '罗马尼亚'
      }
    }
  },
  computed: {
    submenu() {
      return submenu
    }
  },
  created() {
    this.getNoticeType()
    this.getTables()
  },
  methods: {
    importNoticeMsg,
    exportNoticeMsg,
    edit() {
      this.listenSelectType()
      let selectType = ''
      for (const i in this.options) {
        const val = this.options[i]
        if (!val.disabled) {
          selectType = val.value
          break
        }
      }

      if (!selectType) {
        this.msgError('无可选类型')
        return
      }
      const conf = { status: 1 }
      if (conf === 'getMaxSpins') {
        conf.maxSpins = 0
      }
      this.tableData.push({ type: selectType, content: {}, conf: conf })
      this.drawerArr.push({ visible: false })
    },
    changeLang(arr, index) {
      const tableData = this.tableData[index]
      const bakContent = Object.assign({}, tableData.content)
      const newContent = {}
      arr.forEach(item => {
        let oldVal = ''
        if (bakContent[item] !== undefined) {
          oldVal = bakContent[item]
        }
        newContent[item] = oldVal
      })
      this.$set(this.tableData[index], 'content', newContent)
    },
    getNoticeType() {
      this.options = []
      getNoticeMsgType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.options.push({ label: res.data[i], value: i, disabled: false })
          }
        }
      })
    },
    getTables() {
      this.formData = []
      getNoticeMsg(this.queryParams).then(res => {
        if (res.code === 200) {
          res.data.list.forEach((item, index) => {
            this.drawerArr.push({ visible: false })
            res.data.list[index].langs = []
            for (const i in item.content) {
              res.data.list[index].langs.push(i)
            }
          })
          this.tableData = res.data.list
          this.total = res.data.count
          this.listenSelectType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    listenSelectType() {
      for (const k in this.options) {
        const event = this.options[k]
        this.options[k].disabled = false
        for (const i in this.tableData) {
          const val = this.tableData[i]
          if (val.type === event.value) {
            this.options[k].disabled = true
          }
        }
      }
    },
    importUploadSuccess(response, index) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importGameUpdateLang({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.tableData[index].langs = []
          this.tableData[index].content = {}
          for (const i in res.data.body) {
            this.tableData[index].langs.push(i)
            this.tableData[index].content[i] = res.data.body[i]
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(type) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delNoticeMsg({ type: type }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    onSubmit() {
      for (const i in this.tableData) {
        const val = this.tableData[i]
        if (!val.type) {
          this.msgError('请选择类型')
          return
        }
        if (!val.langs) {
          this.msgError('请选择语言')
          return
        }
      }
      const data = JSON.stringify(this.tableData)
      console.log('data', data)
      updateNoticeMsg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
